// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){

	//Prevent actions on clicks of top-level menu items on wide screens (mobile is already being handled above)
	$('.has-mega-menu > a[href=\\#]').click(function(e) {
		e.preventDefault();
	});



	function setMainNavCookie() {
		mainToggleCookie = $('nav.main-navigation .menu > .has-children').hasClass('open') ? 'isActive' : 'notActive';
		    $.cookie('toggleCookie', mainToggleCookie, { path: '/' });

	}

	if ($.cookie('toggleCookie') == 'isActive') {
	    $('nav.main-navigation .menu > .has-children').addClass('open');
	} else {
	    $('nav.main-navigation .menu > .has-children').removeClass('open');
	}





	$("nav.main-navigation .menu > .has-children > a[href=\\#]").click(function (e) {
		e.preventDefault();
	    $('nav.main-navigation .menu > .has-children').toggleClass('open');
	    setMainNavCookie();
	});



	$('.mega-menu').hover(function() {
	 	$(this).parents('.has-mega-menu').toggleClass("mega-chevron");
	});


	$(".mapnav-wrapper .wp-block-column:first-child").click(function(e) {
		e.preventDefault();
		mapNav();
	});



	function mapNav() {
		$('.mapnav-wrapper').toggleClass('open');
	}


	// Mobile Menus

        // Default options

		var menu_content = $('#mobile-navigation');
		var menu_element = $('.mobile-primary li');

		$.each($('.mobile-primary li.our-focus'), function (index, value) {
			$(this).children('a').append($('<span class="arrow"></span>'));
		});

		$.each($('.mobile-primary li.menu-item-has-children'), function (index, value) {
			$(this).children('a').append($('<span class="arrow"></span>'));
		});

		// hamburger btn
		$("#nav-icon").click(function(e) {
		    e.preventDefault();
		    e.stopPropagation();

		    if (menu_content.hasClass( "open" ) ) {
				menu_content.removeClass('open');
				menu_content.addClass('close');
			}else{
				menu_content.addClass('open');
				menu_content.removeClass('close')
			}

		    $(document).one('click', function closeMenu (e){

		        if(menu_content.has(e.target).length === 0){
		            menu_content.removeClass('open');
		            menu_content.addClass('close');
		            $('#nav-icon').removeClass('is-active');
		        } else {
		            $(document).one('click', closeMenu);
		        }
		    });
		});


		// init responsive
		menuStuff();

		$(window).resize(function () {
			menuStuff();
		});

		$('#nav-icon').click(function(e){
			e.preventDefault();
			$(this).toggleClass('is-active');
		});


		function menuStuff() {

			var $browserWidth = window.innerWidth || document.documentElement.clientWidth;

			var menu_content = $('#mobile-navigation');
			var menu_element = $('.mobile-primary li');
			var arrow = $('.our-focus span.arrow' || '.menu-item-has-children span.arrow');
			var submenu_element = $('.sub-menu');

			var hamburger = $('#nav-icon');


			//unbind li click event
			menu_element.unbind();

			arrow.unbind().click(function (e) {

				e.preventDefault();

				if( $(this).closest('li').children('ul').hasClass( "sub-menu" ) ){
					var level = '.sub-menu';
					var element = $(this);
					xsScreen(element, level);

				}
			});

			function xsScreen(element, level) {

				if( element.closest('li').children(level).hasClass('open') ){

	       		 	element.closest('li').children(level).slideUp(250).removeClass("open");
	       		 	element.parent('a').removeClass("active-parent");
	       		 	element.removeClass("open");

		  		}else{

			  		element.closest('li').children(level).slideDown(250).addClass('open');
			  		element.parent('a').addClass("active-parent");
			  		element.addClass("open");
		  		}
			}

			function xlScreen(element, level) {

				if( element.children(level).hasClass('open') ){

	       		 	element.children(level).removeClass("open");
	       		 	element.children('a').removeClass("active-parent");

		  		}else{

			  		element.children(level).show(1).addClass('open');
			  		element.children('a').addClass("active-parent");
		  		}
			}
		}


})(jQuery);
